import { render, staticRenderFns } from "./suggested-articles.vue?vue&type=template&id=fd46ebc0&scoped=true&"
import script from "./suggested-articles.ts?vue&type=script&lang=ts&"
export * from "./suggested-articles.ts?vue&type=script&lang=ts&"
import style0 from "./suggested-articles.scss?vue&type=style&index=0&id=fd46ebc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd46ebc0",
  null
  
)

export default component.exports